/* Section-view tracker (was inline in snippets/dynahome.liquid on index and product pages). */
(function () {
  // =============================================
  // CONFIGURATION
  // =============================================
  const CONFIG = {
    googleAppsScriptUrl: 'https://script.google.com/macros/s/AKfycbyswn9Z0L6AHTTgu45Q9fhhN0S9dIuTgPEepS6mKNoquVwOzOMMasBW8kA7pj43m5cnGw/exec',
    parentSectionSelectors: [
      'section',
      'div.shopify-section',
      'div[id^="shopify-section"]',
      'div.section',
      'article',
      'div.product-container'
    ],
    excludedSections: [
      '#shopify-section-header',
      '#shopify-section-notification',
      '#shopify-section-footer',
      '#shopify-section-ticker-buttons',
      '#shopify-section-homepage-notification',
      '#shopify-section-mobile-nav',
      '#shopify-section-notification',
      '.shopify-section-notification',
      'section.footer',
      '.shopify-section.megamenu.full-width',
      '#shopify-section-megamenu5',
      '#shopify-section-megamenu1',
      '#shopify-section-megamenu2',
      '#shopify-section-megamenu3',
      '#shopify-section-megamenu4',
      '#shopify-section-megamenu6',
      '#shopify-section-megamenu7',
      '#shopify-section-megamenu8',
      '#shopify-section-megamenu9',
      '.megamenu'
    ],
    parentSectionReturnProperty: 'both', // 'id', 'classes', 'both'
    pagesToTrack: ['index', 'product'],
    addToCartSelectors: [
      'form button.product-form__submit'
    ],
    cookieName: 'shopify_section_click',
    cookieExpireDays: 7,
    sectionViewThreshold: 0.5,
    sectionViewDebounceTime: 200,
    debug: false // <--- Set to false to hide all logs
  };

  // =============================================
  // UTILITY FUNCTIONS
  // =============================================
  function log(message, data) {
    if (CONFIG.debug) {
      if (data !== undefined) {
        console.log(message, data);
      } else {
        console.log(message);
      }
    }
  }
  function logError(message, data) {
    if (CONFIG.debug) {
      if (data !== undefined) {
        console.error(message, data);
      } else {
        console.error(message);
      }
    }
  }

  function setCookie(name, value, days) {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(JSON.stringify(value)) + expires + '; path=/';
    log('Cookie set:', { name, value });
  }

  function getCookie(name) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) {
        try {
          return JSON.parse(decodeURIComponent(c.substring(nameEQ.length, c.length)));
        } catch (e) {
          logError('Error parsing cookie:', e);
          return null;
        }
      }
    }
    return null;
  }

  function debounce(func, wait) {
    let timeout;
    return function () {
      const context = this, args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(context, args);
      }, wait);
    };
  }

  function getShopifyUserToken() {
    try {
      if (
        typeof ShopifyAnalytics !== 'undefined' &&
        ShopifyAnalytics.lib &&
        typeof ShopifyAnalytics.lib.user === 'function' &&
        ShopifyAnalytics.lib.user().traits &&
        ShopifyAnalytics.lib.user().traits().uniqToken
      ) {
        return ShopifyAnalytics.lib.user().traits().uniqToken;
      }
    } catch (e) {
      logError('Error getting Shopify user token:', e);
    }
    return 'no_user_token';
  }

  function waitForUserToken(callback, maxAttempts = 10, interval = 300) {
    let attempts = 0;
    function checkUserToken() {
      attempts++;
      const userToken = getShopifyUserToken();
      if (CONFIG.debug) {
        log(`Checking for user token (attempt ${attempts}/${maxAttempts}): ${userToken ? 'Found' : 'Not found'}`);
      }
      if (userToken && userToken !== 'no_user_token') {
        callback(userToken);
        return;
      }
      if (attempts >= maxAttempts) {
        callback('no_user_token_after_retry');
        return;
      }
      setTimeout(checkUserToken, interval);
    }
    checkUserToken();
  }

  // =============================================
  // SECTION & ELEMENT HELPERS
  // =============================================
  function shouldExcludeSection(section) {
    if (!section) return false;
    for (let i = 0; i < CONFIG.excludedSections.length; i++) {
      const exclusion = CONFIG.excludedSections[i];
      // ID
      if (exclusion.startsWith('#') && section.id === exclusion.substring(1)) return true;
      // Class
      if (exclusion.startsWith('.') && section.classList.contains(exclusion.substring(1))) return true;
      // Tag
      if (!exclusion.startsWith('#') && !exclusion.startsWith('.') && section.tagName.toLowerCase() === exclusion.toLowerCase()) return true;
      // Tag.class
      if (exclusion.includes('.')) {
        const [tag, className] = exclusion.split('.');
        if (section.tagName.toLowerCase() === tag.toLowerCase() && section.classList.contains(className)) return true;
      }
    }
    return false;
  }

  function findParentSection(element) {
    let currentElement = element;
    while (currentElement && currentElement !== document.body) {
      for (let i = 0; i < CONFIG.parentSectionSelectors.length; i++) {
        const selector = CONFIG.parentSectionSelectors[i];
        if (selector.includes('.')) {
          // Class selector
          const [tag, className] = selector.split('.');
          if (currentElement.tagName.toLowerCase() === tag && currentElement.classList.contains(className)) {
            if (!shouldExcludeSection(currentElement)) return currentElement;
          }
        } else if (selector.includes('[')) {
          // Attribute selector
          try {
            const attrName = selector.match(/\[(.*?)=/)[1];
            const attrValue = selector.match(/=(.*?)\]/)[1].replace(/"/g, '');
            if (currentElement.tagName.toLowerCase() === selector.split('[')[0]) {
              const attr = currentElement.getAttribute(attrName);
              if (attr && attr.startsWith(attrValue.replace('^', ''))) {
                if (!shouldExcludeSection(currentElement)) return currentElement;
              }
            }
          } catch (e) {
            logError('Error parsing attribute selector:', e);
          }
        } else {
          // Tag selector
          if (currentElement.tagName.toLowerCase() === selector && !shouldExcludeSection(currentElement)) {
            return currentElement;
          }
        }
      }
      currentElement = currentElement.parentElement;
    }
    return null;
  }

  function getParentSectionProperty(parentSection) {
    if (!parentSection) return null;
    switch (CONFIG.parentSectionReturnProperty) {
      case 'id':
        return parentSection.id || 'no_id';
      case 'classes':
        return parentSection.className || 'no_classes';
      case 'both':
        return {
          id: parentSection.id || 'no_id',
          classes: parentSection.className || 'no_classes',
          tagName: parentSection.tagName
        };
      default:
        return parentSection.id || 'no_id';
    }
  }

  // =============================================
  // TEMPLATE DETECTION
  // =============================================
  function detectCurrentTemplate() {
    if (window.Shopify && window.Shopify.template) return window.Shopify.template;
    const bodyClasses = document.body.className;
    if (bodyClasses) {
      if (bodyClasses.includes('template-index')) return 'index';
      if (bodyClasses.includes('template-product')) return 'product';
    }
    const path = window.location.pathname;
    if (path === '/' || path === '/index') return 'index';
    if (path.includes('/products/')) return 'product';
    if (path.includes('/collections/')) return 'collection';
    if (path.includes('/blogs/')) return 'article';
    if (path.includes('/pages/')) return 'page';
    if (path.includes('/cart')) return 'cart';
    return 'unknown';
  }

  // =============================================
  // HOMEPAGE CLICK TRACKING (MODIFIED FOR HREF ONLY)
  // =============================================
  function handleHomepageClick(clickEvent) {
    const clickedElement = clickEvent.target;
    const closestLink = clickedElement.closest('a');
    const hasHref = (clickedElement.tagName === 'A' && clickedElement.href) ||
      (closestLink && closestLink.href);
    if (!hasHref) {
      log('Skipping tracking - no href found on clicked element or parent');
      return;
    }
    const hrefValue = clickedElement.href || (closestLink ? closestLink.href : null);
    log('Tracking click with href:', hrefValue);
    const parentSection = findParentSection(clickedElement);
    const parentSectionProperty = getParentSectionProperty(parentSection);
    if (
      !parentSection ||
      (parentSectionProperty.id === 'no_id' &&
        (parentSectionProperty.classes === 'no_classes' || parentSectionProperty.classes === ''))
    ) {
      log('Skipping tracking - no valid parent section found');
      return;
    }
    setCookie(CONFIG.cookieName, parentSectionProperty, CONFIG.cookieExpireDays);
    const userToken = getShopifyUserToken();
    const currentTemplate = detectCurrentTemplate();
    const payload = {
      timestamp: new Date().toISOString(),
      userToken: userToken,
      pageInfo: {
        url: window.location.href,
        path: window.location.pathname,
        template: currentTemplate
      },
      elementDetails: {
        tagName: clickedElement.tagName,
        id: clickedElement.id || 'no_id',
        classes: clickedElement.className || 'no_classes',
        href: hrefValue,
        text: clickedElement.textContent ? clickedElement.textContent.trim().substring(0, 100) : 'no_text'
      },
      parentSection: parentSectionProperty
    };
    sendToGoogleAppsScript(payload, 'homepage_click');
  }

  function setupHomepageClickTracking() {
    document.body.addEventListener('click', handleHomepageClick, true);
    log('Homepage click tracking set up - tracking only elements with href');
  }

  // =============================================
  // SECTION VIEW TRACKING
  // =============================================
  const viewedSections = new Set();
  const VIEWED_SECTIONS_STORAGE_KEY = 'shopify_viewed_sections';

  function loadViewedSections() {
    try {
      const storedSections = localStorage.getItem(VIEWED_SECTIONS_STORAGE_KEY);
      if (storedSections) {
        const parsedSections = JSON.parse(storedSections);
        if (Array.isArray(parsedSections)) {
          parsedSections.forEach(section => viewedSections.add(section));
        }
      }
    } catch (e) {
      logError('Error loading viewed sections from localStorage:', e);
    }
  }

  function saveViewedSections() {
    try {
      const sectionsArray = Array.from(viewedSections);
      localStorage.setItem(VIEWED_SECTIONS_STORAGE_KEY, JSON.stringify(sectionsArray));
    } catch (e) {
      logError('Error saving viewed sections to localStorage:', e);
    }
  }

  function isElementInViewport(el, threshold = 0.5) {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);
    const elementHeight = rect.bottom - rect.top;
    return visibleHeight / elementHeight >= threshold;
  }

  function trackSectionViews() {
    let sections = [];
    for (let i = 0; i < CONFIG.parentSectionSelectors.length; i++) {
      try {
        const elements = document.querySelectorAll(CONFIG.parentSectionSelectors[i]);
        sections = [...sections, ...Array.from(elements)];
      } catch (e) {
        logError('Error selecting sections with selector:', CONFIG.parentSectionSelectors[i]);
      }
    }
    sections = [...new Set(sections)].filter(section => !shouldExcludeSection(section));
    const sectionsToTrack = [];
    sections.forEach(function (section) {
      const sectionId = section.id || '';
      const sectionClass = section.className || '';
      const sectionIdentifier = `${sectionId}-${sectionClass}`;
      if (viewedSections.has(sectionIdentifier)) return;
      if (isElementInViewport(section, CONFIG.sectionViewThreshold)) {
        viewedSections.add(sectionIdentifier);
        const sectionDetails = {
          id: section.id || 'no_id',
          classes: section.className || 'no_classes',
          tagName: section.tagName
        };
        sectionsToTrack.push(sectionDetails);
      }
    });
    if (sectionsToTrack.length > 0) {
      waitForUserToken(function (userToken) {
        const currentTemplate = detectCurrentTemplate();
        sectionsToTrack.forEach(function (sectionDetails) {
          const payload = {
            timestamp: new Date().toISOString(),
            userToken: userToken,
            pageInfo: {
              url: window.location.href,
              path: window.location.pathname,
              template: currentTemplate
            },
            sectionDetails: sectionDetails
          };
          sendToGoogleAppsScript(payload, 'section_view');
        });
        saveViewedSections();
      });
    }
  }

  const debouncedTrackSectionViews = debounce(trackSectionViews, CONFIG.sectionViewDebounceTime);

  function setupSectionViewTracking() {
    loadViewedSections();
    trackSectionViews();
    window.addEventListener('scroll', debouncedTrackSectionViews);
    window.addEventListener('resize', debouncedTrackSectionViews);
    log('Section view tracking set up');
  }

  // =============================================
  // ADD TO CART TRACKING (SIMPLIFIED WITH DEBOUNCE)
  // =============================================
  let lastAddToCartTimestamp = 0;
  const ADD_TO_CART_DEBOUNCE_MS = 1000; // 1 second debounce

  function setupAddToCartTracking() {
    log('Setting up add to cart tracking - button click only with debounce');
    CONFIG.addToCartSelectors.forEach(selector => {
      try {
        const buttons = document.querySelectorAll(selector);
        if (buttons && buttons.length > 0) {
          log(`Found ${buttons.length} buttons with selector: ${selector}`);
          buttons.forEach(button => {
            button.addEventListener('click', function(event) {
              log('Add to cart button clicked - checking debounce');
              debouncedHandleAddToCartClick('button_click');
            });
          });
        }
      } catch (e) {
        logError('Error finding button with selector:', selector);
      }
    });
  }

  function debouncedHandleAddToCartClick(source) {
    const now = Date.now();
    if (now - lastAddToCartTimestamp < ADD_TO_CART_DEBOUNCE_MS) {
      log('Add to cart event ignored due to debounce', {
        timeSinceLastClick: now - lastAddToCartTimestamp,
        debounceThreshold: ADD_TO_CART_DEBOUNCE_MS
      });
      return;
    }
    lastAddToCartTimestamp = now;
    log('Debounce passed, processing add to cart click');
    handleAddToCartAction(source);
  }

  function handleAddToCartAction(source) {
    const sectionData = getCookie(CONFIG.cookieName);
    if (!sectionData) {
      log('No section data found in cookie');
      return;
    }
    if (sectionData.id === 'direct_navigation' && sectionData.classes === 'no_homepage_section') {
      log('Skipping - direct navigation with no homepage section');
      return;
    }
    log('Processing add to cart action', { source, sectionData });
    sendAddToCartData(sectionData, source);
  }

  function sendAddToCartData(sectionData, source) {
    waitForUserToken(function (userToken) {
      const currentTemplate = detectCurrentTemplate();
      const productTitle = document.querySelector('h1') ? document.querySelector('h1').textContent.trim() : 'Unknown Product';
      let productId = 'unknown_id', productIdSource = 'none';
      if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
        productId = window.ShopifyAnalytics.meta.product.id;
        productIdSource = 'shopify_analytics';
      } else {
        const metaTag = document.querySelector('meta[property="og:product_id"]');
        if (metaTag) {
          productId = metaTag.getAttribute('content');
          productIdSource = 'meta_tag';
        } else {
          const urlMatch = window.location.pathname.match(/\/products\/([^\/\?]+)/);
          if (urlMatch && urlMatch[1]) {
            productId = urlMatch[1];
            productIdSource = 'url_parsing';
          }
        }
      }
      const payload = {
        timestamp: new Date().toISOString(),
        userToken: userToken,
        pageInfo: {
          url: window.location.href,
          path: window.location.pathname,
          template: currentTemplate
        },
        productDetails: {
          id: productId,
          title: productTitle,
          idSource: productIdSource
        },
        homepageSectionData: sectionData,
        eventSource: source
      };
      sendToGoogleAppsScript(payload, 'add_to_cart');
    });
  }

  // =============================================
  // SEND TO GOOGLE APPS SCRIPT
  // =============================================
  function sendToGoogleAppsScript(data, eventType) {
    data.eventType = eventType || 'event';
    log(`Sending ${eventType} data to Google Apps Script`, data);
    try {
      fetch(CONFIG.googleAppsScriptUrl, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
        keepalive: true
      })
      .then(function() {
        log(`${eventType} event data sent successfully`);
      })
      .catch(function(error) {
        logError(`Error sending ${eventType} event data:`, error);
      });
    } catch (e) {
      logError(`Exception when sending ${eventType} event:`, e);
    }
  }

  // =============================================
  // INITIALIZATION
  // =============================================
  function initializeTracking() {
    const currentTemplate = detectCurrentTemplate();
    log(`Initializing tracking for template: ${currentTemplate}`);
    if (currentTemplate === 'index' || currentTemplate === 'collection') {
      setupHomepageClickTracking();
      setupSectionViewTracking();
    } else if (currentTemplate === 'product') {
      setupAddToCartTracking();
      window.addEventListener('load', function() {
        setTimeout(setupAddToCartTracking, 500);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeTracking);
  } else {
    initializeTracking();
  }
  window.addEventListener('load', function() {
    setTimeout(initializeTracking, 500);
  });
})();
